import {
  CLEAR_SIDE_PANEL,
  CREATE_PATIENT_VISIT_REMARKS,
  CREATE_PATIENT_VISIT_REMARKS_ERROR,
  GET_PATIENT_VISIT_REMARKS,
  GET_PATIENT_VISIT_REMARKS_ERROR,
  GET_PATIENT_VISIT_REMARKS_SUCCESS,
} from '../patient-side-panel/PatientSidePanelConstants'

export const patientSidePanelReducerBlackListActions = [
  GET_PATIENT_VISIT_REMARKS,
  GET_PATIENT_VISIT_REMARKS_SUCCESS,
  GET_PATIENT_VISIT_REMARKS_ERROR,
  CREATE_PATIENT_VISIT_REMARKS,
  CREATE_PATIENT_VISIT_REMARKS_ERROR,
  CLEAR_SIDE_PANEL,
]
